"use client";

import { useUser } from "@highway/design-system";
import { dataFetcher, useSnackbar } from "@highway/hwy-design-system";
import { useSearchParams } from "next/navigation";
import React, { useEffect } from "react";

export default function Layout({ children }: { children: React.ReactNode }) {
    const searchParams = useSearchParams();
    const loID = searchParams.get("loId");
    const { getData, hasData } = useUser();
    const { addSnack } = useSnackbar();

    useEffect(() => {
        if (!hasData) {
            populateLOSession();
        }
    }, [hasData]);

    const populateLOSession = async () => {
        try {
            await dataFetcher(`/v1/share/live-share-view-simple?loId=${loID}`);
            getData();
        } catch (err) {
            console.log(err);
            addSnack({ message: "Failed to load weekly newsletter.", type: "error" });
        }
    };

    if (!hasData) return <></>;
    return children;
}
